import React from "react";

import './Products.css';
import { t } from "i18next";
import ImageGrid from "../../components/imagegrid/ImageGrid";

const Products = () => {
    return (
        <div className="products">
            <div className='banner' >
                <img className='products-banner' src={require('./assets/productsBanner.webp')} />
            </div>
            <h1>{t('products.title')}</h1>
            <ImageGrid
                data={[
                    { image: require('./assets/0.webp'), title: t('products.0'), to: '/products/glassware' },
                    { image: require('./assets/1.webp'), title: t('products.1'), to: '/products/handicraft' },
                    { image: require('./assets/2.webp'), title: t('products.2'), to: '/products/homedecor' },
                    { image: require('./assets/3.webp'), title: t('products.3'), to: '/products/home-utility' },
                    { image: require('./assets/4.webp'), title: t('products.4'), to: '/products/silverware' },
                    { image: require('./assets/5.webp'), title: t('products.5'), to: '/products/mmtc' },
                    { image: require('./assets/6.webp'), title: t('products.6'), to: '/products/tableware' },
                ]}
            />
        </div>
    );
}

export default Products;
